import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Card, CardHeader, CardTitle, CardContent } from './ui/Card';
import { BookOpenIcon, SunIcon, FlaskConicalIcon, SproutIcon, ShoppingCartIcon, CalendarDaysIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: BookOpenIcon,
    title: 'Guía Maestra: Huerto en Balcón',
    description: 'PDF de implementación rápida'
  }, {
    icon: SunIcon,
    title: 'El Auditor de Luz',
    description: 'Cómo mapear las sombras de tu calle para no fallar nunca'
  }, {
    icon: FlaskConicalIcon,
    title: "La Mezcla 'No-Tierrosa'",
    description: 'La receta exacta de sustrato para macetas urbanas'
  }, {
    icon: SproutIcon,
    title: 'Catálogo de Velocistas',
    description: 'Las 4 especies que garantizan cosecha en 30 días'
  }, {
    icon: ShoppingCartIcon,
    title: 'Checklist de Montaje Express',
    description: 'Todo lo que necesitas comprar (y lo que no) por menos de $30'
  }, {
    icon: CalendarDaysIcon,
    title: 'Diario de Crecimiento',
    description: 'Tu hoja de ruta día a día hasta la primera ensalada'
  }];
  return <section ref={ref} className="w-full py-10 md:py-16 bg-white" data-id="element-202">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-204">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-3" data-id="element-205">
            Qué Incluye Tu Guía
          </h2>
          <p className="text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-206">
            Todo lo que necesitas para transformar tu balcón en una fuente de
            comida fresca
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-207">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} data-id="element-208">
              <Card className="h-full hover:shadow-lg transition-shadow border-2 hover:border-[#52B788]" data-id="element-209">
                <CardHeader data-id="element-210">
                  <div className="w-10 h-10 bg-[#D8F3DC] rounded-lg flex items-center justify-center mb-3" data-id="element-211">
                    <item.icon className="w-5 h-5 text-[#2D6A4F]" data-id="element-212" />
                  </div>
                  <CardTitle className="text-base text-[#2D6A4F]" data-id="element-213">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent data-id="element-214">
                  <p className="text-sm text-gray-600" data-id="element-215">{item.description}</p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}